
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { errorHandeling } from "../../errorHandeling";

import "./mainPageNotifiEvalStart.scss";

function MainPageNotifiEvalStart({notifText,btnText,btnLink,navLink,commingError}) {

const token = useSelector(state => state.user.token);

let navigate = useNavigate();

//====State start here====
const [error,setError] = useState(null);

const [loading,setLoading] = useState(false);
//====State end here====

//====Event handler start here====
  const handelClickingEvalStart = async()=> {
     
    try {
      setLoading(true);

      const response = await axios.post(
        btnLink,
        {

        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      setLoading(false);
  
      navigate(navLink); // Then navigate to the stat page

    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      setError(errorHandeling(error))
    }

   };

//====Event handler end here====  

  return (
    <div className="eval_start_notif_cover">
        {
            (error) &&
            (<span style={{color:"red",alignSelf:"center"}}>{error}</span>)
        }
        
        {
            (commingError) &&
            (<span style={{color:"red",alignSelf:"center"}}>{commingError}</span>)
        }

        <span className="eval_start_notif_text" dir="rtl">{notifText}</span>
        
        <div className="eval_start_btn_cover">
        <button className="eval_start_notif_btn" dir="rtl" onClick={()=>{handelClickingEvalStart()}}>
            {
              (loading) ?
              ("يرجى الانتظار...")  
              :
              (
                btnText
              )
            }
            
        </button>
        </div>
    </div>
  )
}

export default MainPageNotifiEvalStart